import { useState } from "react";
import { Link } from "react-router-dom";
import { Calculator } from "lucide-react";

const WEEKLY_DISCOUNT = 0.10;

export function RateCalculator({ vehicle }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [reduction, setReduction] = useState(false);
  const days = from && to ? Math.round((new Date(to) - new Date(from)) / 86400000) : 0;
  const valid = days >= vehicle.min_days;
  const base = days * vehicle.daily_rate;
  const discount = days >= 7 ? Math.round(base * WEEKLY_DISCOUNT) : 0;
  const red = reduction ? days * vehicle.excess_reduction_per_day : 0;
  const total = base - discount + red;
  const deposit = Math.round(total * 0.25);
  const bond = reduction ? vehicle.bond_reduced : vehicle.bond_standard;

  return (
    <div className="mt-4 card-hard p-6" data-testid="rate-calculator">
      <div className="grid sm:grid-cols-2 gap-3">
        <label className="block"><span className="overline text-[#595959]">Pickup</span>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} className="input" data-testid="calc-from"/></label>
        <label className="block"><span className="overline text-[#595959]">Return</span>
          <input type="date" value={to} min={from || undefined} onChange={e => setTo(e.target.value)} className="input" data-testid="calc-to"/></label>
      </div>
      <label className="flex items-center gap-2 mt-4 text-sm cursor-pointer">
        <input type="checkbox" checked={reduction} onChange={e => setReduction(e.target.checked)} className="accent-[#BA5A3A]" data-testid="calc-reduction"/>
        Add excess reduction (A${vehicle.excess_reduction_per_day}/day — bond drops to A${vehicle.bond_reduced})
      </label>

      {days > 0 && !valid && (
        <p className="mt-4 text-sm text-[#BA5A3A] font-medium" data-testid="calc-min-warning">Minimum hire for this vehicle is {vehicle.min_days} days.</p>
      )}
      {valid && (
        <div className="mt-5 border-t border-black/10 pt-4 text-sm space-y-1.5" data-testid="calc-breakdown">
          <Row label={`${days} days × A$${vehicle.daily_rate}`} value={base}/>
          {discount > 0 && <Row label="Weekly discount (10%)" value={-discount} accent/>}
          {red > 0 && <Row label={`Excess reduction × ${days} days`} value={red}/>}
          <div className="flex justify-between items-baseline pt-2 border-t border-black/10">
            <span className="font-black text-base">Estimated total</span>
            <span className="text-3xl font-black" data-testid="calc-total">A${total.toLocaleString()}</span>
          </div>
          <div className="flex justify-between text-[#595959]"><span>25% deposit to confirm</span><span data-testid="calc-deposit">A${deposit.toLocaleString()}</span></div>
          <div className="flex justify-between text-[#595959]"><span>Bond pre-authorised at pickup (refundable)</span><span>A${bond.toLocaleString()}</span></div>
          <p className="text-xs text-[#595959] pt-2">{days >= 5 ? "Unlimited kilometres included." : "250 km/day included · A$0.35/km over."} Estimate only — we confirm the final quote by email or WhatsApp.</p>
          <Link to={`/enquiry?vehicle=${vehicle.code}&from=${from}&to=${to}`} className="btn-ochre w-full justify-center mt-3" data-testid="calc-request">
            <Calculator className="w-4 h-4"/> Request these dates
          </Link>
        </div>
      )}
    </div>
  );
}

function Row({ label, value, accent }) {
  return (
    <div className={`flex justify-between ${accent ? "text-[#BA5A3A] font-medium" : ""}`}>
      <span>{label}</span><span>{value < 0 ? "−" : ""}A${Math.abs(value).toLocaleString()}</span>
    </div>
  );
}
